import { CategoryHeaderBase as Header } from '../CategoryHeaderBase';
import { CategoryProductCount as ProductCount } from '../CategoryHeaderProductCount';
import { CategoryNameComp as CategoryName } from '../CategoryName';
import { BreadcrumbComp as Breadcrumb } from '../Breadcrumb';
import FilterAndSorting from '@/components/FilterAndSorting';
import { useSelector } from 'react-redux';
import { deviceWidth } from '@/utils/deviceWidth';

const CategoryHeader1 = (props) => {
  const couponBannerPresent = useSelector(
    (state) => state?.commonReducer?.couponBannerPresent
  );

  return (
    <Header
      classes={
        'category-header-1 flex items-center justify-center flex-column !tw-z-[2]' +
        (couponBannerPresent && deviceWidth < 768 && 'category-pb6px')
      }
    >
      <Breadcrumb classes="category-breadcrumb-1" />
      <CategoryName classes="ttc tc category-name-1" />
      <ProductCount classes="tc center product-count-1" />
      <FilterAndSorting />
    </Header>
  );
};

export default CategoryHeader1;
